import { SK } from '@/lib/storageKeys'

export const LOCALE_KEY = SK.locale
export const SUPPORTED_LOCALES = ['zh', 'en'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]
export const FALLBACK_LOCALE: Locale = 'zh'

export function resolveInitialLocale(): Locale {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const saved = window.localStorage.getItem(LOCALE_KEY)
      if (saved && (SUPPORTED_LOCALES as readonly string[]).includes(saved)) return saved as Locale
    }
  } catch {
    // ignore storage errors (e.g. SSR, private mode)
  }
  if (typeof navigator !== 'undefined') {
    const rawLangs: string[] =
      Array.isArray((navigator as unknown as { languages?: string[] }).languages) &&
      (navigator as unknown as { languages?: string[] }).languages!.length > 0
        ? (navigator as unknown as { languages: string[] }).languages
        : navigator.language
          ? [navigator.language]
          : []
    for (const raw of rawLangs) {
      const lower = raw.toLowerCase()
      if (lower.startsWith('zh')) return 'zh'
      const short = lower.slice(0, 2)
      if (short && (SUPPORTED_LOCALES as readonly string[]).includes(short)) return short as Locale
    }
  }
  return FALLBACK_LOCALE
}
